import CurrencyDropDown from './components/dropdown/Currency';
import DefaultDropDown from './components/dropdown/Default';

const DropDown = {
	Default: DefaultDropDown,
	Currency: CurrencyDropDown,
};

export default DropDown;
